/**
 * Select Stateless Component
 */

import * as React from "react";
import { Translate } from "react-localize-redux";
import { ITranslationItem } from "root/shared/BankCatalogEnum";
import { ISelectItem, ISelectProps } from "root/store/CajitaStore";

const translationOption: (
  items: ITranslationItem[],
  target: string
) => string = (items: ITranslationItem[], target: string): string => {
  const index: number = items.findIndex(
    (x: ITranslationItem) => x.code === target
  );
  if (index === -1) return "";

  return items[index].id;
};

const Select: React.StatelessComponent<ISelectProps> = (
  props: ISelectProps
): React.ReactElement<object> => (
  <>
    {props.children}
    <div>
      <select
        id={`${props.id}Tag`}
        className={`${props.classes.join(" ")} form-control custom-select`}
        onChange={(event: React.ChangeEvent<HTMLSelectElement>): void =>
          props.change(props.id, event.currentTarget.value)
        }
        value={props.value}
      >
        {props.inputItems.map((item: ISelectItem, index: number) => (
          <Translate key={`translate${index}`}>
            {/* tslint:disable-next-line:typedef */}
            {({ translate }): JSX.Element => (
              <option key={index} value={item.value}>
                {props.translationTargets !== undefined
                  ? translationOption(props.translationTargets, item.value) ===
                    ""
                    ? item.text
                    : translate(
                        translationOption(props.translationTargets, item.value)
                      )
                  : item.text}
              </option>
            )}
          </Translate>
        ))}
      </select>
    </div>
  </>
);

export { Select };



// WEBPACK FOOTER //
// ./src/components/UI/Select/SelectComponent.tsx